export const TOGGLE_COMPARE_PRODUCT = 'Common::ToggleCompareProduct';
